import { memo as Memo, useMemo } from 'react';

//* HOC's
import { withLanguageContext } from 'context';

//* Helpers
import config from 'helpers/_config';

//* Components
import MenuItemCollapse from './MenuItemCollapse';
import BottomTabNavigation from './BottomTabNavigation';
import CustomLink from 'components/common/CustomLink';

//* Styles
import MobileMenuStyle from './style';

const MobileMenu = Memo(({ isOpen, openMenu, topPosition, menuData, translate }) => {
	//! Menu Items
	const menuItems = useMemo(() => {
		if (!menuData) return null;

		const { key: aboutKey, ...aboutProps } = menuData.about || {};
		const { key: placesKey, ...placesProps } = menuData.places || {};
		const { key: planKey, ...planProps } = menuData.planYourTrip || {};
		const thingsTodoChildren = menuData.thingsTodo?.children || [];
		const thingsTodoSlug = menuData.thingsTodo?.slug;

		return (
			<ul>
				{menuData.about && (
					<MenuItemCollapse
						key={aboutKey || 'about'}
						{...aboutProps}
					/>
				)}

				{thingsTodoChildren.map((place, k) => {
					const { key: placeKey, ...placeProps } = place || {};

					return (
						<MenuItemCollapse
							key={placeKey || k}
							{...placeProps}
							slug={thingsTodoSlug}
						/>
					);
				})}

				{menuData.places && (
					<MenuItemCollapse
						key={placesKey || 'places'}
						{...placesProps}
					/>
				)}

				{menuData.planYourTrip && (
					<MenuItemCollapse
						key={planKey || 'plan-your-trip'}
						{...planProps}
					/>
				)}
			</ul>
		);
	}, [menuData]);

	return (
		<>
			<MobileMenuStyle
				className={isOpen ? 'opened' : ''}
				topPosition={topPosition}
			>
				<div className={`menu-cont secondaryColor1-bg`}>
					<div className='menu-inner-cont'>{menuItems}</div>
					<div className='links-wrap'>
						<CustomLink
							className='font-ping-bold h6 uppercase experience'
							url={config.routes.experience.path}
						>
							{translate('experiences')}
						</CustomLink>

						<CustomLink
							className='font-ping-bold h6 uppercase blog'
							url={config.routes.articles.path}
						>
							{translate('blog')}
						</CustomLink>
					</div>
				</div>
			</MobileMenuStyle>

			<BottomTabNavigation
				menuIsOpen={isOpen}
				openMenu={openMenu}
			/>
		</>
	);
});

export default withLanguageContext(MobileMenu, ['translate']);
